export default "__VITE_ASSET__ocDUPwgd__"